import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomMultiSelect = _resolveComponent("CustomMultiSelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CustomMultiSelect, {
      values: _ctx.chosenPartnerRegions,
      "onUpdate:values": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chosenPartnerRegions) = $event)),
      class: "w-64",
      label: "Vælg partnerkommuner",
      items: _ctx.selectableRegions,
      "item-text": "title",
      "item-value": "id"
    }, null, 8, ["values", "items"]),
    _createElementVNode("button", {
      type: "button",
      class: "mt-2 border rounded-md bg-white px-4 border-gray-400 py-3",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSaveClicked && _ctx.onSaveClicked(...args)))
    }, "Gem")
  ]))
}